import React, { Component } from "react";
// import Widget02 from "../../../Widgets/Widget02";
// import PopUp from "./PopUp";
import Carousel, { consts } from "react-elastic-carousel";

import Select from "react-select";
import moment from "moment";

import {
  Button,
  Col,
  Form,
  Row,
  TabContent,
  NavLink,
  NavItem,
  Nav,
  TabPane,
  Input,
  FormGroup,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import "./formsTable.css";
import "./baseForms.css";
import { Redirect, Link } from "react-router-dom";
import { checkPermission } from "../../../../../Helper";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl } from "../../../../../baseurl";
import swal from "@sweetalert/with-react";
import "./myReactSelect.css";
import "../../../../../index.css";
import "react-datepicker/dist/react-datepicker.css";
// import bar1 from "./../../../../assets/img/brand/Rectangle24.png";
// import bar2 from "./../../../../assets/img/brand/Rectangle25.png";
// import bar3 from "./../../../../assets/img/brand/Rectangle26.png";
// import bar4 from "./../../../../assets/img/brand/Rectangle27.png";
// import notes from "../../../../../assets/img/brand/notes.png";
// import layer1 from "../../../../../assets/img/brand/layer1.png";
// import calender from "../../../../../assets/img/brand/calender4.png";
// import clock from "../../../../../assets/img/brand/clock.png";
import {
  BootstrapTable,
  TableHeaderColumn,
  // InsertButton,
} from "react-bootstrap-table";
// import tooltipText from "../../ShortCutComponents/tooltipText";
import Responseloader from "../../../ShortCutComponents/ResponseLoader";
import PermissionModal from "../../../ShortCutComponents/PermissionModal";
import Modal from "react-bootstrap/Modal";
import { GetIp } from "../../../ShortCutComponents/Get_ip";

import ItemLoadComponent from "../RestaurantForm/RestMenu";
// import paginationFactory from "react-bootstrap-table2-paginator";
// import DataTable from "../../../Tables/DataTable/DataTable";

var thisContex;
var username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companyId = localStorage.getItem("companyId");
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var companySymbol = "";
companySymbol = companySymbolCurrency;
// console.log("username :>> ", username);
function addZeroTFormator(cell, row, enumObject, index) {
  let newCell = "";
  if (cell > 0 && cell < 10) {
    newCell = "00" + cell;
  } else if (cell >= 10 && cell < 100) {
    newCell = "0" + cell;
  } else {
    newCell = cell;
  }
  return <div>{newCell}</div>;
}
function styleRet(cell, row, enumObject, index) {
  let newCell = "";
  if (cell === "RET") {
    newCell = "CRD_NOTE";
  } else {
    newCell = cell;
  }

  return <div>{newCell}</div>;
}

// function dueFormators(cell, row, enumObject, index) {
//   let newCell = "";
//   if (typeof cell === "string") {
//     cell = parseFloat(cell);
//   }
//   newCell = cell?.toLocaleString("en-US", {
//     maximumFractionDigits: 2,
//     minimumFractionDigits: 2,
//   });
//   newCell = companySymbol + " " + newCell;
//   return newCell;
// }

// function dueFormators(cell, row, enumObject, index) {
//   let newCell = "";

//   newCell = cell?.toLocaleString("en-US", {
//     maximumFractionDigits: 2,
//     minimumFractionDigits: 2,
//   });
//   newCell = companySymbol + " " + newCell;
//   return <div>{newCell}</div>;
// }
function dueFormators(cell, row, enumObject, index) {
  let newCell = "";
  newCell = cell; //  2200
  if (typeof cell === "string") {
    newCell = parseFloat(cell);
  }

  if (newCell) {
    newCell = newCell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });

    newCell = companySymbolCurrency + " " + newCell;
  } else {
    newCell = "-";
  }
  return <div> {newCell}</div>;
}

// const customTotal = (from, to, size) => {
//   return (
//     <div>
//       <span className="react-bootstrap-table-pagination-total">
//         Showing {from} to {to} of 214 Results
//       </span>
//       ;
//     </div>
//   );
// };

const createCustomInsertButton = (onClick) => {
  // return (
  //   <InsertButton
  //     btnText="CustomInsertText"
  //     btnContextual="btn-warning"
  //     className="my-custom-class"
  //     btnGlyphicon="glyphicon-edit"
  //     onClick={() => this.handleInsertButtonClick(onClick)}
  //   />
  // );
};
function dueFormatorsCurrencySymbl(cell, row, enumObject, index) {
  let newCell = "";

  newCell = row.DayNumber + " " + row.Days;
  return <div>{newCell}</div>;
}

function dueFormatorsCurrencySymblDUE(cell, row, enumObject, index) {
  let newCell = "";
  newCell = cell?.toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  newCell = row.CurrencySymbl + " " + newCell;
  return <div>{newCell}</div>;
}
function calculateDaysLeft(startDatee, endDatee) {
  if (!moment.isMoment(startDatee)) startDatee = moment(startDatee);
  if (!moment.isMoment(endDatee)) endDatee = moment(endDatee);

  var res = endDatee.diff(startDatee, "days");
  return res;
}
const columnHover = (cell, row, enumObject, rowIndex) => {
  if (row.t === "RET") {
    return (
      "CreditNote Amount= " +
      dueFormators(row.totalInvoiceAmount) +
      "\nApply Credit Amount= " +
      dueFormators(row.creditNoteApplyAmount) +
      "\nRefund Apply Amount= " +
      dueFormators(row.refundAmount)
    );
  } else {
    return (
      "Invoice Amount= " +
      dueFormators(row.totalInvoiceAmount) +
      "\nReceipt Amount= " +
      dueFormators(row.totalReceiptAmount) +
      "\nCredit Note Amount= " +
      dueFormators(row.totalCreditNoteAmount) +
      "\nAdjusted Amount = " +
      dueFormators(row?.totalInvoiceAmount)
    );
  }
};
const getUserIp = async function () {
  let res = await GetIp();
  return { userIp: res.ip, userCountry: res.country };
  thisContex.setState({
    userIp: res.ip,
    userCountry: res.country,
  });
};
function indexN(cell, row, enumObject, index) {
  return <div>{index + 1}</div>;
}
class PriceListDetail extends Component {
  constructor(props) {
    super(props);
    thisContex = this;
    // this.onPageChange = this.onPageChange.bind(this);
    this.renderShowsTotal = this.renderShowsTotal.bind(this);
    // this.onSizePerPageList = this.sizePerPageListChange.bind(this);
    this.toggle = this.toggle.bind(this);
    let tempLogedIn = false;
    let defaultdate = new Date();
    defaultdate = moment(defaultdate).format("YYYY-MM-DD");
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }

    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      activeTab: new Array(6).fill("1"),
      logInStatus: tempLogedIn,
      invoiceIdState: "",
      divcontainer: false,
      defaultdate: defaultdate,
      redirect: false,
      redirectToCreditNote: false,
      redirectToRecurring: false,
      redirectSomeOnePaid: false,
      redirectToCreativeInvoice: false,
      redirectToEstimate: false,
      loadingResponce: false,
      invoiceCount: "",
      overDueCount: "",
      DueCount: "",
      DraftCount: "",
      PaidCount: "",
      dataShowPerPage: "",
      dataLength: 0,
      indexLength: 0,
      fetchAllData: [],
      seen: false,
      idChild: "",
      pageCounter: 1,
      pageSize: "",
      rolesPermission: false,
      permission: true,
      showPopipModal: false,
      redirectToEstimateUpdate: false,
      showPermissionModal: false,
      filterSelectedMsg: "",
      invoiceUrl: "/CreativeInvoice",
    };
  }
  togglePop = (invoiceId, customerId) => {
    this.setState({
      seen: !this.state.seen,
      showPopipModal: !this.state.showPopipModal,
      idChild: invoiceId,
      customerIdChild: customerId,
    });
  };
  // onPageChange(page) {
  // }
  // sizePerPageListChange(sizePerPage) {
  // }
  renderShowsTotal(start, to, total) {
    return (
      <p style={{ color: "blue" }}>
        From {start} to {to}, totals is {total}&nbsp;&nbsp;(its a customize
        text)
      </p>
    );
  }
  pageListRenderer = ({ pages, onPageChange }) => {
    // just exclude <, <<, >>, >
    const pageWithoutIndication = pages.filter(
      (p) => typeof p.page !== "string"
    );
    return (
      <div>
        {pageWithoutIndication.map((p) => (
          <button
            className="btn btn-success"
            onClick={() => onPageChange(p.page)}
          >
            {p.page}as
          </button>
        ))}
      </div>
    );
  };
  setDelete = (row) => {
    let id = row.ITEM_ID;
    let invoiceDate = row.issued_date;
    invoiceDate = moment(invoiceDate).format("YYYY-MM-DD");

    const { userIp, userCountry } = thisContex.state;

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/masterData/deleteItem`,

            {
              DeleteId: id,
              username: username,
              companyId: companyId,
              userIp,
              userCountry,
            },

            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            let resMessage = response.data.message;

            let resDate = response.data.resDate;

            let itemCode = response.data.itemCode;
            if (resMessage == "Negavtive Item") {
              swal({
                title: `Item of code ${itemCode} is being negetive on ${resDate}`,
                text: "issue",
                icon: "error",
              });
              thisContex.setState({
                loadingResponce: false,
              });
              // thisContex.toggle();
            } else {
              Swal.fire("Deleted!", "Record has been deleted.", "success");
              thisContex.getOverviewData();
            }
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  setDeleteRec = (row) => {
    let id = row.INVOICE_ID;

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/masterData/deleteInvoiceOverViewRec`,
            { id: id, companyId: companyId, username: username },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            thisContex.getOverviewData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  redirectToOrder = (cell, row) => {
    // console.log(cell);
    console.log(row);
    // let type = row.trans_type
    // return;
    if (cell === "view") {
      this.setState({
        showItemForm: !this.state.showItemForm,
        row_id: row.ITEM_ID,
        updateCheck: 1,
      });
      // thisContex.props.history.push({
      //   pathname: "/IssueNote",
      //   state: {
      //     id: row?.issue_id,
      //     updateCheck: 2,
      //     goBackUrl: "/IssueNoteOverview",
      //   },
      // });
    } else if (cell === "update") {
      this.setState({
        showItemForm: !this.state.showItemForm,
        row_id: row.ITEM_ID,
        updateCheck: 0,
      });
      // thisContex.props.history.push({
      //   pathname: "/IssueNote",
      //   state: {
      //     id: row?.issue_id,
      //     updateCheck: 0,
      //     goBackUrl: "/IssueNoteOverview",
      //   },
      // });
    }

    //     this.setState({
    //   redirectToRefund: true,
    //   cust_id: row.CUSTOMER_ID,
    //   amount: row.due,
    //   sale_ret_id: row.INVOICE_ID,
    //   customer_name: row.name,
    //   inv_date: new Date(row.due_date_status),
    //   companyCurSymbol: row.CURRENCY_SYMBOL,
    //   currencyId: row.CURRENCY_ID,
    //   inv_doc_no: row.no,
    //   conv_rate: row.convertion_rate,
    // });
  };
  onPageNext = (DataTableName) => {
    let pageCounter = this.state.pageCounter;

    this.setState(
      {
        pageCounter: pageCounter + 1,
      },
      () => {
        this.getOverviewData(DataTableName);
        // Do an API call with this.state.searchTerm
      }
    );
  };

  onPageLast = (dataTableName) => {
    let pageSize = this.state.pageSize;

    let pageCounter;
    if (dataTableName == "All") {
      pageCounter = parseInt(this.state.invoiceCount / pageSize);
    } else if (dataTableName == "overDue") {
      pageCounter = parseInt(this.state.overDueCount / pageSize);
    } else if (dataTableName == "due") {
      pageCounter = parseInt(this.state.DueCount / pageSize);
    } else if (dataTableName == "Paid") {
      pageCounter = parseInt(this.state.PaidCount / pageSize);
    } else if (dataTableName == "draft") {
      pageCounter = parseInt(this.state.DraftCount / pageSize);
    }

    this.setState(
      {
        pageCounter: pageCounter + 1,
      },
      () => {
        this.getOverviewData(dataTableName);
        // Do an API call with this.state.searchTerm
      }
    );
  };
  onPageFirst = (dataTableName) => {
    let pageCounter = 0;

    this.setState(
      {
        pageCounter: pageCounter + 1,
      },
      () => {
        this.getOverviewData(dataTableName);
        // Do an API call with this.state.searchTerm
      }
    );
  };
  onPagePrev = (dataTableName) => {
    let pageCounter = this.state.pageCounter;
    let pp = pageCounter;
    pp++;
    // console.log(this.state.pageCounter);
    // this.setState((prevState) => {
    //   return { pageCounter: prevState.pageCounter + 1 };
    // });

    this.setState(
      {
        pageCounter: pageCounter - 1,
      },
      () => {
        this.getOverviewData(dataTableName);
        // Do an API call with this.state.searchTerm
      }
    );
  };

  // handleLoopsFunction(dataLength, NextPrev) {
  //   let callData = this.state.fetchAllData;
  //   console.log("callData", callData);
  //   let todayDate = new Date();
  //   let increamentLength = 0;
  //   let decreamenttLength = dataLength;
  //   todayDate = moment(todayDate).format("YYYY-MM-DD");
  //   let all = [];
  //   let overDue = [];
  //   let due = [];
  //   let draft = [];
  //   let paid = [];
  //   let wOverview = 0;
  //   let wDue = 0;
  //   let wDraft = 0;
  //   let loopControlVar = 0;
  //   let loopControlVarLength;
  //   if (NextPrev == "Next") {
  //     loopControlVar = dataLength;
  //     loopControlVarLength = Number(dataLength + 8);
  //     for (let index = dataLength; index <= Number(dataLength + 8); index++) {
  //       // callData[index].tcAmount = callData[index]?.tcAmount;
  //       console.log(index);
  //       console.log(callData[index].PostedYN);
  //       if (callData[index].t === "RET") {
  //         var completeAmount =
  //           callData[index].due -
  //           callData[index].discountTc +
  //           callData[index].saleTaxTc;

  //         let ref_amt = callData[index].refundAmount;
  //         if (callData[index].creditNoteAmount === completeAmount) {
  //           callData[index].due = Math.abs(
  //             completeAmount - callData[index].creditNoteAmount
  //           );
  //         } else {
  //           callData[index].due = Math.abs(
  //             completeAmount - callData[index].creditNoteAmount - ref_amt
  //           );
  //         }

  //         callData[index].paid = callData[index].creditNoteAmount + ref_amt;
  //       } else {
  //         if (callData[index].t === "INV") {
  //           //for debuging some error
  //           callData[index].due =
  //             callData[index].due -
  //             callData[index].paid -
  //             callData[index].creditNoteAmountInv;
  //           callData[index].due = callData[index]["due"].toFixed(4);
  //         }

  //         if (callData[index].paid && callData[index].t === "INV") {
  //           callData[index].due =
  //             callData[index].due - callData[index].creditNoteAmount;

  //           callData[index].paid =
  //             callData[index].paid + callData[index].creditNoteAmount;
  //           // callData[index].creditNoteAmount + ye wala removal
  //           // callData[index].saleTaxTc;

  //           callData[index].unAppliedAmount =
  //             callData[index].unAppliedAmount - callData[index].paid;
  //         }
  //         if (callData[index].paid && callData[index].t !== "INV") {
  //           callData[index].due =
  //             callData[index].due -
  //             callData[index].paid -
  //             callData[index].creditNoteAmount;
  //           callData[index].paid =
  //             callData[index].paid + callData[index].creditNoteAmount;
  //           callData[index].due = callData[index]["due"].toFixed(4);
  //         }
  //       }

  //       callData[index].due_date_status = moment(
  //         callData[index].due_date_status
  //       ).format("YYYY-MM-DD");
  //       //    ye hai wo removal       if (callData[index].due !== 0 && callData[index].t !== "RET") {

  //       if (callData[index].t !== "RET") {
  //         callData[index].due = Math.abs(
  //           callData[index].due -
  //             callData[index].discountTc +
  //             callData[index].saleTaxTc
  //         );
  //       }

  //       if (callData[index].PostedYN === 1) {
  //         if (
  //           callData[index].t === "INV" ||
  //           callData[index].t === "RET" ||
  //           callData[index].t === "EST"
  //         ) {
  //           all.push(callData[index]);
  //         }

  //         if (
  //           todayDate > callData[index].due_date_status &&
  //           (callData[index].t === "INV" || callData[index].t === "RET")
  //         ) {
  //           if (callData[index]?.due > 0) {
  //             wOverview += callData[index].due;
  //             overDue.push(callData[index]);
  //           }
  //         }

  //         if (
  //           todayDate <= callData[index].due_date_status &&
  //           (callData[index].t === "INV" ||
  //             callData[index].t === "RET" ||
  //             callData[index].t === "EST") &&
  //           callData[index].due
  //         ) {
  //           due.push(callData[index]);
  //           let amtMultiply =
  //             callData[index].due * callData[index].convertion_rate;
  //           wDue += amtMultiply;
  //         }
  //         if (callData[index].due === 0) {
  //           callData[index]["Paid"] = "Paid";
  //           paid.push(callData[index]);
  //         }
  //       } else {
  //         if (callData[index].t === "INV") {
  //           draft.push(callData[index]);
  //           wDraft += callData[index].due;
  //         }
  //         if (callData[index].t === "EST") {
  //           draft.push(callData[index]);
  //           wDraft += callData[index].due;
  //         }
  //       }

  //       increamentLength++;
  //     }
  //   }
  //   else {
  //     for (let index = Number(dataLength + 8); index >= dataLength; index--) {
  //       // callData[index].tcAmount = callData[index]?.tcAmount;
  //       console.log(index);
  //       console.log(callData[index].PostedYN);
  //       if (callData[index].t === "RET") {
  //         var completeAmount =
  //           callData[index].due -
  //           callData[index].discountTc +
  //           callData[index].saleTaxTc;

  //         let ref_amt = callData[index].refundAmount;
  //         if (callData[index].creditNoteAmount === completeAmount) {
  //           callData[index].due = Math.abs(
  //             completeAmount - callData[index].creditNoteAmount
  //           );
  //         } else {
  //           callData[index].due = Math.abs(
  //             completeAmount - callData[index].creditNoteAmount - ref_amt
  //           );
  //         }

  //         callData[index].paid = callData[index].creditNoteAmount + ref_amt;
  //       } else {
  //         if (callData[index].t === "INV") {
  //           //for debuging some error
  //           callData[index].due =
  //             callData[index].due -
  //             callData[index].paid -
  //             callData[index].creditNoteAmountInv;
  //           callData[index].due = callData[index]["due"].toFixed(4);
  //         }

  //         if (callData[index].paid && callData[index].t === "INV") {
  //           callData[index].due =
  //             callData[index].due - callData[index].creditNoteAmount;

  //           callData[index].paid =
  //             callData[index].paid + callData[index].creditNoteAmount;
  //           // callData[index].creditNoteAmount + ye wala removal
  //           // callData[index].saleTaxTc;

  //           callData[index].unAppliedAmount =
  //             callData[index].unAppliedAmount - callData[index].paid;
  //         }
  //         if (callData[index].paid && callData[index].t !== "INV") {
  //           callData[index].due =
  //             callData[index].due -
  //             callData[index].paid -
  //             callData[index].creditNoteAmount;
  //           callData[index].paid =
  //             callData[index].paid + callData[index].creditNoteAmount;
  //           callData[index].due = callData[index]["due"].toFixed(4);
  //         }
  //       }

  //       callData[index].due_date_status = moment(
  //         callData[index].due_date_status
  //       ).format("YYYY-MM-DD");
  //       //    ye hai wo removal       if (callData[index].due !== 0 && callData[index].t !== "RET") {

  //       if (callData[index].t !== "RET") {
  //         callData[index].due = Math.abs(
  //           callData[index].due -
  //             callData[index].discountTc +
  //             callData[index].saleTaxTc
  //         );
  //       }

  //       if (callData[index].PostedYN === 1) {
  //         if (
  //           callData[index].t === "INV" ||
  //           callData[index].t === "RET" ||
  //           callData[index].t === "EST"
  //         ) {
  //           all.push(callData[index]);
  //         }

  //         if (
  //           todayDate > callData[index].due_date_status &&
  //           (callData[index].t === "INV" || callData[index].t === "RET")
  //         ) {
  //           if (callData[index]?.due > 0) {
  //             wOverview += callData[index].due;
  //             overDue.push(callData[index]);
  //           }
  //         }

  //         if (
  //           todayDate <= callData[index].due_date_status &&
  //           (callData[index].t === "INV" ||
  //             callData[index].t === "RET" ||
  //             callData[index].t === "EST") &&
  //           callData[index].due
  //         ) {
  //           due.push(callData[index]);
  //           let amtMultiply =
  //             callData[index].due * callData[index].convertion_rate;
  //           wDue += amtMultiply;
  //         }
  //         if (callData[index].due === 0) {
  //           callData[index]["Paid"] = "Paid";
  //           paid.push(callData[index]);
  //         }
  //       } else {
  //         if (callData[index].t === "INV") {
  //           draft.push(callData[index]);
  //           wDraft += callData[index].due;
  //         }
  //         if (callData[index].t === "EST") {
  //           draft.push(callData[index]);
  //           wDraft += callData[index].due;
  //         }
  //       }

  //       decreamenttLength--;
  //     }
  //   }

  //   let setDataLength;
  //   if (NextPrev == "Next") {
  //     setDataLength = dataLength + increamentLength;
  //   } else {
  //     setDataLength = Math.abs(dataLength - decreamenttLength);
  //   }
  //   console.log("dataLength", dataLength + increamentLength);
  //   thisContex.setState({
  //     dataLength: setDataLength,
  //     fetchAllData: callData,
  //     OverViewDataTable: all,
  //     OverViewDataTableOverdue: overDue,
  //     OverViewDataTableDue: due,
  //     OverViewDataTableDraft: draft,
  //     OverViewDataTablePaid: paid,
  //     // OverViewDataTableRec: callData2,

  //     // clientNameHeading: callData[0]?.name,
  //     // isLoadedName: isLoadedName,
  //     // overDueWiget: overDueWiget,
  //     // dueWiget: dueWiget,
  //     // draftWiget: draftWiget,
  //     loadingResponce: false,

  //     //recurringWiget: wRecurring,
  //   });
  // }
  convertDraftToInvoice = (row) => {
    // console.log("roww", row);

    let date = moment(row.issued_date).format("YYYY-MM-DD");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to convert draft to invoice",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, sure to convert !",
    }).then((result) => {
      if (result.isConfirmed) {
        thisContex.setState({ loadingResponce: true });

        //     console.log(parseFloat(row.tc_amt_with_st_disc));
        //      console.log(parseFloat(row.LABOUR));
        //     console.log(parseFloat(row.total_tire_fee));
        //     console.log(parseFloat(row.tire_disposal_amount));
        //     return;
        axios
          .post(
            `${baseurl}/masterData/updatePostYNInvoice`,
            {
              id: row.INVOICE_ID,
              companyId: companyId,
              invoice_ref_no: "",
              pONumber: "",
              invoice_date: date,
              currency_Id: row.CURRENCY_ID,
              customer_id: row.CUSTOMER_ID,
              customerName: row.name,
              customerEmail: "",
              randomCode: "",
              arr_jrn_det: "",
              conv_Rate: row.convertion_rate,
              sumSaleTaxVal: row.saleTaxTc,
              totalnet: row.tc_amt_with_st_disc,
              totaldiscount: row.discountTc,
              totalamount: row.tcAmount,
              documentNo: "",
              username: username,
              labour: row.LABOUR,
              totalTireFee: row.total_tire_fee,
              totalTireDisposal: row.tire_disposal_amount,
              totalAmountIncAll:
                parseFloat(row.tc_amt_with_st_disc) +
                parseFloat(0) +
                parseFloat(row.total_tire_fee) +
                parseFloat(row.tire_disposal_amount),
              // userIp,
              // userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((res) => {
            thisContex.setState({
              loadingResponce: false,
            });
            let resMessage = res.data.message;
            // alert
            let resDate = res.data.resDate;
            let itemCode = res.data.itemCode;

            if (resMessage == "Negavtive Item") {
              swal({
                title: `Item of code ${itemCode} is being negetive on ${resDate}`,
                text: "issue",
                icon: "error",
              });

              // this.toggle();
            } else {
              window.location.reload();
            }
            // thisContex.setState({ loadingResponce: false });
            // var latestDocNo = res.data.inv_doc_no;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };
  convertEstimateToInvoice = (row) => {
    // console.log("roww", row);

    let date = moment(row.issued_date).format("YYYY-MM-DD");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to convert estimate to invoice",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, sure to convert !",
    }).then((result) => {
      if (result.isConfirmed) {
        thisContex.setState({ loadingResponce: true });
        // "update");
        // return;
        axios
          .post(
            `${baseurl}/masterData/updatePostYNEstimateInvoice`,
            {
              id: row.INVOICE_ID,
              companyId: companyId,
              invoice_ref_no: "",
              pONumber: "",
              invoice_date: date,
              currency_Id: row.CURRENCY_ID,
              customer_id: row.CUSTOMER_ID,
              customerName: row.name,
              customerEmail: "",
              randomCode: "",
              arr_jrn_det: "",
              conv_Rate: row.convertion_rate,
              sumSaleTaxVal: row.saleTaxTc,
              totalnet: row.tc_amt_with_st_disc,
              totaldiscount: row.discountTc,
              totalamount: row.tcAmount,
              documentNo: "",
              username: username,
              // userIp,
              // userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((res) => {
            thisContex.setState({ loadingResponce: false });
            var latestDocNo = res.data.inv_doc_no;
            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };
  redirectToOrderRec = (cell, row) => {
    if (cell === "update" && row.T === "REC") {
      this.setState({
        redirectToRecurring: true,
        id: row.INVOICE_ID,
        invoiceSymbol: row.CURRENCY_SYMBOL,
        updateCheck: 0,
      });
    } else if (cell === "view" && row.T === "REC") {
      this.setState({
        redirectToRecurring: true,
        id: row.INVOICE_ID,
        invoiceSymbol: row.CURRENCY_SYMBOL,
        updateCheck: 2,
      });
    }
  };

  statusFormator = (cell, row, enumObject, index) => {
    let type = row.trans_type;
    return (
      <div>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="primary"
            // disabled={rolesPermission}
            // onClick={() => this.showUpdateModal(row)}
            onClick={() => {
              this.redirectToOrder("update", row);
            }}
          >
            Edit
          </Button>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="danger"
            // disabled={rolesPermission}
            onClick={() => this.setDelete(row)}
          >
            Delete
          </Button>
        </span>

        {/* <span>
          <Button
            type="submit"
            size="sm"
            color="primary"
            title="Create return for this issue note"
            hidden={type === "Return" ? true : false}
            // disabled={rolesPermission}
            onClick={() => {
              this.redirectToOrder("return", row, type);
            }}
          >
            <i className="fa fa-euro"></i>
            <i className="fa fa-euro"></i>
          </Button>
        </span> */}
        <span>
          <Button
            className="mr-1"
            size="sm"
            title="Preview"
            onClick={() => {
              this.redirectToOrder("view", row);
            }}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </span>

        {/*  {Math.abs(row.sumPayment + row.sumAmount) ? (
          <span>
            <Button
              style={{ margin: "3px" }}
              type="submit"
              size="sm"
              color="primary"
              // onClick={() => this.showUpdateModal(row)}
              onClick={() => {
                this.redirectToOrderRem("updateRemb", row);
              }}
            >
              <i className="fa fa-euro"></i>
              <i className="fa fa-euro"></i>
            </Button>
          </span>
        ) : (
          ""
        )}
      */}
        {/* <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="#dc9797"
            // disabled={rolesPermission}
            // onClick={() => this.showUpdateModal(row)}
            onClick={() => {
              this.redirectToOrderRate("update", row);
            }}
          >
            <i className="cui-settings icons "></i>
          </Button>
        </span> */}
      </div>
    );
  };
  handleChangeEvent = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      [name]: value,
    });
  };
  statusFormatorRec = (cell, row, enumObject, index) => {
    return (
      <div>
        <>
          {/* <span className="mr-1 badge badge-warning">
            {row.DayNumber} {row.Days}
          </span> */}
          <span>
            <Button
              style={{ margin: "3px" }}
              type="submit"
              size="sm"
              color="success"
              disabled={this.state.rolesPermission ? true : false}
              onClick={() => {
                this.redirectToOrderRec("update", row);
              }}
            >
              Update
            </Button>
          </span>

          <span>
            <Button
              style={{ margin: "3px" }}
              type="submit"
              size="sm"
              color="danger"
              onClick={() => this.setDeleteRec(row)}
              disabled={this.state.rolesPermission ? true : false}
            >
              Delete
            </Button>
          </span>
          <span>
            <Button
              className="mr-1"
              style={{ margin: "3px" }}
              // type="submit"
              size="sm"
              // color="success"
              onClick={() => {
                this.redirectToOrderRec("view", row);
              }}
            >
              <i className="fa fa-eye"></i>
            </Button>
          </span>
        </>
      </div>
    );
  };
  refreshSubCat(catId, itemTypeId, label) {
    axios
      .post(
        `${baseurl}/lovs/getItemSubCategory`,
        {
          companyId: companyId,
          username: username,
          itemCatId: catId,
          itemTypeId: itemTypeId,
          // itemCatId: itemCatField[0]?.id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let itemSubCatLov = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          itemSubCatLov.push({
            id: responseData[loop]?.id,
            label: `${responseData[loop]?.description}`,
          });
        }
        if (catId) thisContex.getOverviewData("", "", catId);
        // setGetDataItemSubCat({
        //   ...getDataItemSubCat,
        //   itemSubCatOptions: itemSubCatdata,
        // });
        if (catId) {
          let filterSelectedMsg = label;
          this.setState({
            itemSubCatLov,
            selectedCatId: catId,
            filterSelectedMsg,
            catMsg: { id: catId, label: label },
            subCatMsg: null,
          });
        } else {
          this.setState({
            itemSubCatLov,
            selectedCatId: catId,
            // subCatMsg: label ? true : false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  refreshCat(selectedCatId) {
    axios
      .post(
        `${baseurl}/lovs/getItemCategory`,
        { companyId: companyId, username: username, itemTypeId: 2 },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("response agy bai", response);
        let responseData = response.data.data;
        let itemCatLov = [];
        let catObj = null;
        for (let loop = 0; loop < responseData.length; loop++) {
          itemCatLov.push({
            id: responseData[loop]["id"],
            label: `${responseData[loop]["description"]}`,
          });
          if (selectedCatId === responseData[loop]["id"]) {
            catObj = {
              id: responseData[loop]["id"],
              label: `${responseData[loop]["description"]}`,
            };
          }
        }
        console.log("itemCatdata", itemCatLov);
        this.setState({
          itemCatLov,
          itemCatItemSub: catObj,
        });
        // setGetDataItemCat({ ...getDataItemCat, itemCatOptions: itemCatdata });
        // setGetDataItemCatItemSub({
        //   itemCatOptionsItemSub: itemCatdata,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  ////////////////////////////-----END------////////////////////////////////

  async componentDidMount() {
    //const a = multiply(4, 2);

    await this.asyncRollCheck();
    // this.whichInvoiceOpen();

    const permission = this.state.permission;
    // console.log("funcData", permission);

    if (permission) {
      thisContex.refreshCat();
      thisContex.refreshSubCat("", 2);
      // 0 means user is allowed, 1 means user is not allowed
      this.getOverviewData();
      getUserIp();
    }
  }

  // whichInvoiceOpen() {
  //   username === "ishtiyak_master@gmail.com" &&
  //     thisContex.setState({ invoiceUrl: "/CreativeInvoice" }); //CreateTireInvoice
  // }

  handleSubmitAddItemCat = async (e) => {
    e.preventDefault();
    const { userIp, userCountry } = await getUserIp();

    const { itemCategoryDesc, itemCategoryCode, itemType } = this.state;
    console.log(itemCategoryDesc);
    console.log(itemCategoryCode);
    console.log(itemType);
    if (itemCategoryDesc && itemCategoryCode !== null && itemType?.id) {
      axios
        .post(
          `${baseurl}/masterData/getAddItemCategory`,
          {
            companyId,
            catDesc: itemCategoryDesc,
            catCode: itemCategoryCode,
            username: username,
            itemType: itemType?.id,
            userIp,
            userCountry,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          if (response.data.code === 501) {
            swal({
              title: "Invalid Operation",
              text: "Duplicate Code is Not Allowed",
              icon: "error",
            });
            // setCheckitemCatChild(false);
          } else {
            swal({
              title: "Saved Successfully!",
              text: "Menu Type is Added",
              icon: "success",
            }).then((value) => {
              thisContex.toggleAddNew();
              thisContex.refreshCat();
            });
          }
        })
        .catch(function (error) {
          // console.log("erooor", error);
          // console.log("response", error.data.code);
          console.log(error.message);
          // setCheckitemCatChild(false);
          // if (error.message === "Request failed with status code 501") {
          //   swal({
          //     title: "Invalid Operation",
          //     text: "Duplicate Entry Not Allowed",
          //     icon: "error",
          //   });
          // } else {
          swal({
            title: "Invalid Operation",
            text: "Something went wrong, try again",
            icon: "error",
          });
          // }
        });
    } else {
      // setErrorItemCatChild(true);
      // setCheckitemCatChild(false);
    }
  };
  selectItemCatItemSub = (e) => {
    this.setState({
      itemCatItemSub: e,
    });
  };
  handleSubmitAddItemSubCat = async (e) => {
    e.preventDefault();
    const { userIp, userCountry } = await getUserIp();

    const { itemCatItemSub, itemSubCatDesc, itemSubCatCode } = this.state;
    console.log(itemCatItemSub);
    console.log(itemSubCatDesc);
    console.log(itemSubCatCode);
    if (itemCatItemSub?.id && itemSubCatDesc !== null && itemSubCatCode) {
      axios
        .post(
          `${baseurl}/masterData/getAddItemSubCategory`,
          {
            companyId,
            subCatDesc: itemSubCatDesc,
            subCatCode: itemSubCatCode,
            username: username,
            itemCat: itemCatItemSub?.id,
            // catDesc: itemCategoryDesc,
            // catCode: itemCategoryCode,
            // username: username,
            // itemType: itemType?.id,
            userIp,
            userCountry,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          if (response.data.code === 501) {
            swal({
              title: "Invalid Operation",
              text: "Duplicate Code is Not Allowed",
              icon: "error",
            });
            // setCheckitemCatChild(false);
          } else {
            swal({
              title: "Saved Successfully!",
              text: "Menu Category is Added",
              icon: "success",
            }).then((value) => {
              thisContex.toggleAddNewSubCat();
              thisContex.refreshSubCat("", 2);
              // setCheckitemCatChild(false);
              // openItemCategory();
              // getItemCat("", data.itemCatCode);
            });
          }
        })
        .catch(function (error) {
          // console.log("erooor", error);
          // console.log("response", error.data.code);
          console.log(error.message);
          // setCheckitemCatChild(false);
          // if (error.message === "Request failed with status code 501") {
          //   swal({
          //     title: "Invalid Operation",
          //     text: "Duplicate Entry Not Allowed",
          //     icon: "error",
          //   });
          // } else {
          swal({
            title: "Invalid Operation",
            text: "Something went wrong, try again",
            icon: "error",
          });
          // }
        });
    } else {
      swal({
        label: "Invalid Entry",
        icon: "warning",
        text: "Kindly recheck fields",
      });
      // setErrorItemCatChild(true);
      // setCheckitemCatChild(false);
    }
  };
  asyncRollCheck = async () => {
    let rolId = 2;
    let adminRoleId = 1;
    let readYn = 1;
    let writeYn = 0;
    let formType = "OverView";

    let empId = localStorage.getItem("employeeId");
    let makeTrueFlase = "";
    //ye localStorage se lani h login k wqt
    let permissionFunction = await checkPermission(
      empId,
      adminRoleId,
      rolId,
      readYn,
      writeYn,
      formType
    );
    //permission = permission[0];
    // console.log(
    //   "gggggggg",
    //   permissionFunction[0],
    //   " ",
    //   permissionFunction[1],
    //   " ",
    //   permissionFunction[2]
    // );
    if (permissionFunction[1] == 1 && permissionFunction[2] == 0) {
      makeTrueFlase = true;
    } else {
      makeTrueFlase = false;
    }

    // console.log("a", a);
    this.setState({
      permission: permissionFunction[0],
      rolesPermission: makeTrueFlase,
      //showPermissionModal: false,
      //showPermissionModal: permission ? false : true,
    });
  };
  ////////////////-----Show Table LOV and Data------////////////////////

  getOverviewData(lastPageParam, itemSubCatId, catId, label) {
    // 1st call for Load data in Data table. We are on the main page.
    let isLoadedName = this.props.location.state?.idFromClientOverview;
    let companyId = localStorage.getItem("companyId");
    axios
      .post(
        `${baseurl}/invoice/getPageSize`,
        {
          companyId: companyId,

          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (res) {
        let wOverview = 0;
        let wDue = 0;
        let wDraft = 0;
        let pageSize = res.data.data[0]["page_size"];

        let offSet =
          parseFloat(thisContex.state.pageCounter - 1) * parseFloat(pageSize);

        // if (lastPageOffset !== "" || lastPageOffset !== undefined) {
        //   offSet = lastPageOffset;
        // }
        let differCountPage = "";
        // thisContex.setState({ loadingResponce: true });
        console.log(thisContex.props);
        axios
          .post(
            `${baseurl}/restaurant/getPriceListDetail`,
            {
              companyId: companyId,
              username: username,
              itemTypeId: 2,
              itemSubCatId,
              catId,
              id: thisContex.props.location.state?.id,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log(res.data.data);
            let getItemData = res.data.data;
            //Storing users detail in state array object

            if (label) {
              let a = thisContex.state.filterSelectedMsg;
              console.log(typeof a);
              a = a.split(">");
              console.log(a);
              thisContex.setState({
                filterSelectedMsg: a[0] + " > " + label,
                OverViewDataTable: getItemData,
                subCatMsg: { id: itemSubCatId, label: label },
              });
            }
            thisContex.setState({
              // loadingResponce: false,
              // isLoadedTableData: true,
              // catMsg: label ? true : false,
              OverViewDataTable: getItemData,
            });
          })
          .catch((err) => {
            console.log(err);
          });

        axios
          .post(
            `${baseurl}/lovs/getItemType`,
            { companyId: companyId, username: username, id: 2 },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            // let mydata = [];
            let responseData = response.data.data[0];
            let itemType = {};

            itemType = {
              id: responseData["ITEM_TYPE_ID"],
              label: `${responseData["ITEM_TYPE_DESC"]}`,
            };
            console.log(itemType);
            thisContex.setState({
              itemType,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  ////////////////------End-----////////////////////
  getData() {
    axios
      .post(
        `${baseurl}/lovs/getItem`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let getItemData = res.data.data;
        this.setState({
          isLoadedTableData: true,
          tableData: getItemData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  myArrow({ type, onClick, isEdge }) {
    const pointer = type === consts.PREV ? "<" : ">";
    return (
      <Button onClick={onClick} disabled={isEdge}>
        {pointer}
      </Button>
    );
  }
  itemLoad = () => {
    const { catMsg, subCatMsg } = this.state;
    console.log(catMsg, subCatMsg);
    this.setState({
      row_id: "-1",
      showItemForm: !this.state.showItemForm,
    });
    this.getOverviewData("", subCatMsg?.id, catMsg?.id, "");
    // this.getLovsLoad();
  };
  loremAll() {
    const {
      OverViewDataTable,
      itemCatLov,
      itemSubCatLov,

      catMsg,
      subCatMsg,
    } = this.state;

    const options = {
      //paginationShowsTotal: true,
      // paginationShowsTotal: this.renderShowsTotal,
      //totalSize: 30,
      //dataTotalSize: 100,
      // pageList: 30,
      page: 1,
      sizePerPage: 8,
      pageStartIndex: 1,
      paginationSize: 5,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      // pageListRenderer: this.pageListRenderer,
      // insertBtn: this.createCustomInsertButton,
      // onPageChange: this.onPageChange,
      // onSizePerPageList: this.sizePerPageListChange,
      // sizePerPageList: [
      //   {
      //     text: "5",
      //     value: 5,
      //   },
      //   {
      //     text: "10",
      //     value: 10,
      //   },
      //   {
      //     text: "All",
      //     value: 30,
      //   },
      // ],
    };

    return (
      <div>
        <div className="d-flex flex-row">
          <div className="col-md-1 pt-2">
            <Label className="font-weight-bold mr-3">Type</Label>
          </div>
          {itemCatLov?.length > 0 ? (
            <div className="col-md-11" style={{ marginLeft: "-12px" }}>
              <Carousel
                itemsToShow={4}
                enableTilt
                itemsToScroll={4}
                itemPosition={consts.CENTER}
                itemPadding={[0, 0]}
                pagination={false}
                // renderArrow={this.myArrow}
              >
                {itemCatLov?.map((item) => (
                  <div className="row" key={item.id}>
                    <div className="col-sm-2 justify-left">
                      <Link>
                        <button
                          type="button"
                          title={item.label}
                          className="btn-1 btn-warning text-truncate px-2"
                          style={
                            catMsg?.id === item.id
                              ? { border: "solid #3a3a8e 3px", width: "183px" }
                              : { width: "183px" }
                          }
                          onClick={() =>
                            this.refreshSubCat(item.id, "", item.label)
                          }
                        >
                          {item.label}
                        </button>
                      </Link>
                    </div>
                    {/* <div
                  className="col-sm-1 cross"
                  style={{
                    borderRadius: "6px",
                    paddingLeft: "10px",
                    height: "19px",
                    padding: 0,
                    marginLeft: "120px",
                    marginTop: "-7px",
                    backgroundColor: "black",
                  }}
                >
                  <i
                    // onClick={() => dlt_btn(item.fav_menu_id)}
                    class="fa fa-close"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  />
                </div> */}
                  </div>
                  // <div
                  //   key={item.id}
                  //   onClick={() => {
                  //   }}
                  // >
                  //   {item.label}
                  // </div>
                ))}
              </Carousel>
            </div>
          ) : null}
          {/* <div className="col-md-1 ">
            <button
              className="btn btn-outline-success rounded-pill "
              title={"Create New Issue Note"}
              disabled={this.state.rolesPermission}
              style={{ marginLeft: "-12px" }}
              onClick={() => this.toggleAddNew()}
            >
              <i class="fa fa-plus pr-2" aria-hidden="true"></i>
              Type
            </button>
          
          </div> */}
        </div>
        <div className="d-flex flex-row mt-3">
          <div className="col-md-1 pt-2">
            <Label className="font-weight-bold mr-3">Category</Label>
          </div>
          {itemSubCatLov?.length > 0 ? (
            <div className="col-md-11" style={{ marginLeft: "-12px" }}>
              <Carousel
                itemsToShow={4}
                enableTilt
                itemsToScroll={4}
                itemPosition={consts.CENTER}
                itemPadding={[0, 0]}
                pagination={false}
                // renderArrow={this.myArrow}
              >
                {itemSubCatLov?.map((item) => (
                  <div className="row" key={item.id}>
                    <div className="col-sm-2 justify-left">
                      <Link>
                        <button
                          type="button"
                          className="btn-1 btn-warning text-truncate px-2"
                          title={item.label}
                          style={
                            subCatMsg?.id === item.id
                              ? { border: "solid #3a3a8e 3px", width: "183px" }
                              : { width: "183px" }
                          }
                          onClick={() =>
                            this.getOverviewData("", item.id, "", item.label)
                          }
                        >
                          {item.label}
                        </button>
                      </Link>
                    </div>
                    {/* <div
                  className="col-sm-1 cross"
                  style={{
                    borderRadius: "6px",
                    paddingLeft: "10px",
                    height: "19px",
                    padding: 0,
                    marginLeft: "120px",
                    marginTop: "-7px",
                    backgroundColor: "black",
                  }}
                >
                  <i
                    // onClick={() => dlt_btn(item.fav_menu_id)}
                    class="fa fa-close"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  />
                </div> */}
                  </div>
                  // <div
                  //   key={item.id}
                  //   onClick={() => {
                  //   }}
                  // >
                  //   {item.label}
                  // </div>
                ))}
              </Carousel>
            </div>
          ) : null}
          {/* <div className="col-md-1 mt-1" style={{ marginLeft: "26px" }}>
            <div className="float-right">
              <button
                class="btn btn-outline-success rounded-pill "
                title={"Create New Issue Note"}
                style={{ marginLeft: "-39px" }}
                disabled={this.state.rolesPermission}
                onClick={() => this.toggleAddNewSubCat(this.state.catMsg)}
              >
                <i class="fa fa-plus pr-2" aria-hidden="true"></i>
                Category
              </button> 
            </div>
          </div> */}
        </div>
        <div class="row">
          <div class="col-md-10">
            <p style={{ position: "relative", top: "45px" }}>
              Showing {thisContex.state.dataShowPerPage} of{" "}
              {thisContex.state.invoiceCount}{" "}
            </p>
            <div
              style={{
                position: "relative",

                left: "200px",
                top: "6px",
              }}
            >
              <button
                disabled={thisContex.state.pageCounter > 1 ? false : true}
                style={{
                  padding: "7px",

                  fontSize: "11px",
                  color: "#428bca",
                  border: "1px solid powderblue",
                  width: "50px",
                }}
                onClick={() => this.onPageFirst("All")}
              >
                First
              </button>

              <button
                disabled={thisContex.state.pageCounter > 1 ? false : true}
                style={{
                  padding: "7px",

                  fontSize: "11px",
                  color: "#428bca",
                  border: "1px solid powderblue",
                  width: "50px",
                }}
                onClick={() => this.onPagePrev("All")}
              >
                Prev
              </button>

              <button
                disabled={
                  thisContex.state.pageCounter * thisContex.state.pageSize >=
                  thisContex.state.invoiceCount
                    ? true
                    : false
                }
                style={{
                  padding: "7px",

                  fontSize: "11px",
                  color: "#428bca",
                  border: "1px solid powderblue",
                  width: "50px",
                }}
                //className="btn btn-success"
                onClick={() => this.onPageNext("All")}
              >
                Next
              </button>
              <button
                disabled={
                  thisContex.state.pageCounter * thisContex.state.pageSize >=
                  thisContex.state.invoiceCount
                    ? true
                    : false
                }
                style={{
                  padding: "7px",

                  fontSize: "11px",
                  color: "#428bca",
                  border: "1px solid powderblue",
                  width: "50px",
                }}
                onClick={() => this.onPageLast("All")}
              >
                Last
              </button>
            </div>
          </div>

          <div class="col-md-2"></div>
        </div>
        <BootstrapTable
          data={OverViewDataTable}
          striped
          // pagination
          hover
          search
          tableHeaderClass="rpr_header"
          tableBodyClass="rpr_body"
          containerClass="rpr_container"
          options={options}
          version="4"
        >
          <TableHeaderColumn
            dataField="catDescription"
            dataAlign="center"
            // dataFormat={indexN}
            dataSort={true}
            width="10%"
            isKey={true}
          >
            Menu Type
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="subCatDescription"
            dataAlign="center"
            // dataFormat={indexN}
            dataSort={true}
            width="10%"
          >
            Menu Category
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="itemCode"
            dataAlign="center"
            dataSort={true}
            width="10%"
          >
            Code
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="ITEM_DESC"
            dataAlign="center"
            // dataFormat={indexN}
            dataSort={true}
            width="10%"
            // row="0"
            // rowSpan="2"
            // isKey={true}
          >
            Item Name
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            dataField="old_rate"
            width="12%"
            dataSort={true}
            // dataFormat={addZeroTFormator}
          >
            Old Price
          </TableHeaderColumn>
          <TableHeaderColumn
            dataAlign="center"
            dataField="rate"
            width="12%"
            dataSort={true}
            // dataFormat={addZeroTFormator}
          >
            New Price
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="right"
            dataField="due_date_status"
            width="22%"
            dataFormat={this.statusFormator}
            // row="0"
            // rowSpan="2"
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }

  toggle(tabPane, tab) {
    // console.log("zzzzzzzzz--------", tab);
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    if (tab == "1") {
      this.getOverviewData("All");
    } else if (tab == "2") {
      this.getOverviewData("overDue");
    } else if (tab == "3") {
      this.getOverviewData("Due");
    } else if (tab == "4") {
      this.getOverviewData("draft");
    } else if (tab == "5") {
      this.getOverviewData("Paid");
    } else if (tab == "6") {
      this.getOverviewData("Rec");
    }
    this.setState({
      activeTab: newArray,
      pageCounter: 1,
    });
  }
  toggleAddNew = () => {
    thisContex.setState({
      showModalAddNew: !this.state.showModalAddNew,
    });
  };
  toggleAddNewSubCat = (selectedCatId) => {
    // if (!this.state.showModalAddNewSubCat) this.refreshCat(selectedCatId);
    console.log(selectedCatId);
    if (selectedCatId?.id) {
      let catObj = { id: selectedCatId?.id, label: selectedCatId?.label };

      thisContex.setState({
        showModalAddNewSubCat: !this.state.showModalAddNewSubCat,
        itemCatItemSub: catObj,
      });
    } else {
      thisContex.setState({
        showModalAddNewSubCat: !this.state.showModalAddNewSubCat,
      });
    }
  };
  togglePermission() {
    // console.log("asasaas =" + thisContex.state.showPermissionModal);
    thisContex.setState({
      showPermissionModal: !thisContex.state.showPermissionModal,
    });
  }

  tabPane() {
    return (
      <React.Fragment>
        <TabPane tabId="1">{this.loremAll()}</TabPane>
        {/* <TabPane tabId="2">{this.loremOverDue()}</TabPane>
        <TabPane tabId="3">{this.loremDue()}</TabPane>
        <TabPane tabId="4">{this.loremEstimates()}</TabPane>
        <TabPane tabId="5">{this.loremPaid()}</TabPane> */}
        {/* <TabPane tabId="6">{this.loremRecurring()}</TabPane> */}
      </React.Fragment>
    );
  }

  render() {
    const {
      // dataShowPerPage,
      // invoiceCount,
      // clientNameHeading,
      // overDueWiget,
      // dueWiget,
      // draftWiget,
      propsConvRate,
      // propsInvoiceDocNo,
      // propsCustomerName,
      redirectCreditNoteApp,
      propsCustomerId,

      propsDue,
      invoiceIdState,
      propsIssuedDate,
      propsName,
      propsRefNo,
      propsPaid,
      amount,
      cust_id,
      sale_ret_id,
      customer_name,
      inv_date,
      companyCurSymbol,
      currencyId,
      // recurringWiget,
      inv_doc_no,
      conv_rate,
      loadingResponce,
      // permission,
      // rolesPermission,
      showPermissionModal,
      // wOverdue,
      // wDue,
      // wDraft,
      updateToInv,
      showItemForm,
      row_id,
      itemType,
      checkitemCatChild,
      itemCategoryCode,
      itemCategoryDesc,
      itemCatItemSub,
      itemSubCatDesc,
      itemSubCatCode,
      itemSubCatLov,
      itemCatLov,
      filterSelectedMsg,
      catMsg,
      subCatMsg,
    } = this.state;

    // var handleChange = (e) => {
    //   this.setState({ divcontainer: !this.state.divcontainer });
    // };
    const x = this.state.divcontainer;
    if (this.state.logInStatus === false) {
      return <Redirect to="/login" />;
    } else if (loadingResponce) {
      return <Responseloader />;
    } else if (!this.state.permission) {
      return <PermissionModal moduleName="sales" />;
    }
    if (this.state.redirectCreditNoteApp === true) {
      // console.log("this.state.customer_name" + this.state.customer_name);
      return (
        <Redirect
          push
          to={{
            pathname: "/CreateNoteApplication",
            state: {
              redirectCreditNoteApp: redirectCreditNoteApp,
              propsCustomerId: propsCustomerId,
              propsConvRate: propsConvRate,

              propsDue: propsDue,
              propsIssuedDate: propsIssuedDate,
              propsRefNo: propsRefNo,
              propsPaid: propsPaid,
              invoiceIdState: invoiceIdState,
              propCurrId: this.state.propCurrId,
              invoiceSymbol: this.state.invoiceSymbol,
              propsName: propsName,
            },
          }}
        />
      );
    }
    return this.state.redirect ? (
      <Redirect
        push
        to={{
          // pathname: "/CreativeInvoice", //CreateTireInvoice
          pathname: `${this.state.invoiceUrl}`,
          state: { id: this.state.id, updateCheck: this.state.updateCheck },
        }}
      />
    ) : this.state.redirectToEstimateUpdate ? (
      <Redirect
        push
        to={{
          pathname: `${this.state.invoiceUrl}`,
          state: { id: this.state.id, updateCheck: this.state.updateCheck },
        }}
      />
    ) : this.state.redirectToCreditNote ? (
      <Redirect
        push
        to={{
          pathname: "/CreateCreditNote",
          state: {
            id: this.state.id,
            updateCheck: this.state.updateCheck,
            invoiceSymbol: this.state.invoiceSymbol,
          },
        }}
      />
    ) : this.state.redirectToRecurring ? (
      <Redirect
        push
        to={{
          pathname: "/RecurringInvoices",
          state: {
            id: this.state.id,
            updateCheck: this.state.updateCheck,
            invoiceSymbol: this.state.invoiceSymbol,
          },
        }}
      />
    ) : this.state.redirectSomeOnePaid ? (
      <Redirect
        push
        to={{
          pathname: "/SomeOnePaid",
          state: {
            propCustomerId: this.state.idd,
            propInvoiceId: this.state.propInvoiceId,
            propCurrId: this.state.propCurrId,
            invoiceSymbol: this.state.invoiceSymbol,
            goBackUrl: "/OverviewInvoice",
          },
        }}
      />
    ) : this.state.redirectSomeOnePaidView ? (
      <Redirect
        push
        to={{
          pathname: "/CreateCreditNote",
          state: {
            updateCheck: 2,
            id: this.state.propInvoiceId,
            invoiceSymbol: this.state.invoiceSymbol,
          },
        }}
      />
    ) : this.state.redirectToCreativeInvoice ? (
      <>
        <Redirect
          push
          to={{
            pathname: `${this.state.invoiceUrl}`,

            state: {
              updateCheck: this.state.updateCheck,
              id: this.state.id,
            },
          }}
        />
      </>
    ) : this.state.redirectToEstimate ? (
      <>
        <Redirect
          push
          to={{
            pathname: "/CreateEstimate",
            state: {
              updateCheck: this.state.updateCheck,
              id: this.state.id,
              updateToInv,
            },
          }}
        />
      </>
    ) : this.state.redirectToRefund ? (
      <Redirect
        push
        to={{
          pathname: "/SaleRefund",
          state: {
            amount: amount,
            cust_id: cust_id,
            sale_ret_id: sale_ret_id,
            customer_name: customer_name,
            inv_date: inv_date,
            companyCurSymbol: companyCurSymbol,
            currencyId: currencyId,
            inv_doc_no: inv_doc_no,
            conv_rate: conv_rate,
          },
        }}
      />
    ) : (
      <div className="animated fadeIn">
        <div className="row mb-2">
          <Col>
            {/* <OwlCarousel
              // items={5}
              autoPlay
              className="owl-theme"
              //  autoplay
              loop
              //  margin={10}
              nav
              // animateIn
            >
              {getDataEmpType?.responseData?.map((item, index) => (
                <div className="button-row">
                  <i
                    onClick={() => dlt_btn(item.fav_menu_id)}
                    class="fa fa-plus cross"
                    aria-hidden="true"
                  />
                  <Link to={item.ref_link_det}>
                    <button type="button" class="btn-1 btn-warning">
                      {item.menu_desc}
                    </button>
                  </Link>
                </div>
              ))}
            </OwlCarousel> */}
          </Col>
        </div>

        <div className="animated fadeIn">
          <div className="O-V-boarder">
            <div className="O-V-heading-bar">
              <div className="col-md-4  p-2">
                <strong>
                  <h4>Restaurant Item Price Detail </h4>
                </strong>
                {/* <p>{filterSelectedMsg}</p> */}
              </div>
              <div
                className="col-md-8 pt-2 OV_Res_Bar"
                // style={{ textAlign: "right" }}
              >
                {/* <>
                  <div className="float-right">
                    <button
                      class="btn btn-outline-success rounded-pill mx-2"
                      title={"Create New Issue Note"}
                      disabled={this.state.rolesPermission}
                      onClick={() => this.itemLoad()}
                    >
                      <i class="fa fa-plus pr-2" aria-hidden="true"></i>
                      New Menu Item
                    </button>
                     
                  </div>
                </> */}
              </div>
            </div>

            <Row>
              <Col xs="12" md="12" className="mb-4">
                <TabContent activeTab={this.state.activeTab[0]}>
                  {this.tabPane()}
                </TabContent>
              </Col>
            </Row>
          </div>
        </div>
        <Modal
          //show={t}
          show={showPermissionModal}
          size="md"
          onHide={this.togglePermission}
        >
          <Modal.Header
            closeButton
            className="Creative-Invoice-header-styling p-3"
          >
            <Modal.Title>Access Denied!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Dear Username, your user roll is not allowed to access.
          </Modal.Body>
        </Modal>
        {showItemForm ? (
          <>
            <ItemLoadComponent
              toggle={this.itemLoad}
              EditData={row_id}
              selectedData={{ catMsg, subCatMsg }}
            />
          </>
        ) : null}
        <Modal
          show={this.state.showModalAddNew}
          size="md"
          onHide={this.toggleAddNew}
          backdrop="static"
        >
          <Modal.Header
            closeButton
            onClick={() => this.toggleAddNew()}
            className="Creative-Invoice-header-styling"
          >
            <strong>
              <h4> Add Menu Type </h4>
            </strong>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form name="simpleForm" onSubmit={this.handleSubmitAddItemCat}>
                  <div className="row">
                    <div
                      translate="no"
                      className="col-md-12"
                      style={{ marginBottom: "12px" }}
                    >
                      <Label translate="yes" style={{ fontWeight: "bold" }}>
                        Item Type:
                        <h8 style={{ color: "tomato" }}>*</h8>
                      </Label>

                      <Select
                        value={itemType}
                        // onChange={this.onChangeItemType}
                        // options={itemTypeOptions}
                        required
                        name="itemType"
                        isClearable
                        isDisabled
                        placeholder={
                          localStorage.getItem("comp_lang") == "ur"
                            ? "--منتخب کریں--"
                            : localStorage.getItem("comp_lang") == "ar"
                            ? "--يختار--"
                            : "--select--"
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <Label style={{ fontWeight: "bold" }}>
                        Menu Type Code
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="itemCategoryCode"
                        id="itemCategoryCode"
                        onChange={(e) => this.handleChangeEvent(e)}
                        required
                        // onChange={inputEvent}
                        value={itemCategoryCode}
                      />
                    </div>
                    <div className="col-md-6" style={{ marginBottom: "12px" }}>
                      <Label style={{ fontWeight: "bold" }}>
                        Menu Type Description
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="itemCategoryDesc"
                        id="itemCategoryDesc"
                        required
                        // onChange={inputEvent}
                        onChange={(e) => this.handleChangeEvent(e)}
                        value={itemCategoryDesc}
                      />
                    </div>
                  </div>
                  <Button
                    // onClick={handleSubmitAddItem}
                    disabled={checkitemCatChild}
                    type="submit"
                    className="mr-1 invoiceSubmitButton"
                  >
                    Save Changes
                  </Button>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showModalAddNewSubCat}
          size="md"
          onHide={this.toggleAddNewSubCat}
          backdrop="static"
        >
          <Modal.Header
            closeButton
            onClick={this.toggleAddNewSubCat}
            className=" Creative-Invoice-header-styling"
          >
            <strong>
              <h4> Add Menu Category </h4>
            </strong>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                {/* onSubmit={handleSubmitAddItemSubCat} */}
                <Form
                  name="simpleForm2"
                  onSubmit={this.handleSubmitAddItemSubCat}
                >
                  <div className="row">
                    <div className="col-md-12" style={{ marginBottom: "12px" }}>
                      <Label style={{ fontWeight: "bold" }}>
                        Menu Type:
                        <h8 style={{ color: "tomato" }}>*</h8>
                      </Label>

                      <Select
                        isClearable
                        value={itemCatItemSub}
                        onChange={this.selectItemCatItemSub}
                        options={itemCatLov}
                        required
                        name="itemCatItemSub"
                        placeholder={"-- Select --"}
                      />
                    </div>
                    <div className="col-md-6">
                      <Label style={{ fontWeight: "bold" }}>
                        Menu Category Code
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="itemSubCatCode"
                        id="itemSubCatCode"
                        onChange={(e) => this.handleChangeEvent(e)}
                        value={itemSubCatCode}
                        required
                      />
                    </div>
                    <div className="col-md-6" style={{ marginBottom: "12px" }}>
                      <Label style={{ fontWeight: "bold" }}>
                        Menu Category Description
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="itemSubCatDesc"
                        id="itemSubCatDesc"
                        onChange={(e) => this.handleChangeEvent(e)}
                        value={itemSubCatDesc}
                        required
                      />
                    </div>
                  </div>
                  <Button
                    // onClick={handleSubmitAddItem}
                    type="submit"
                    className="mr-1 invoiceSubmitButton "
                    // disabled={checkitemSubCatChild}
                  >
                    Save Changes
                  </Button>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default PriceListDetail;
